import { StructureBuilder } from '@wix/add-panel-common';
import { identity } from 'ramda';
import React, { createContext } from 'react';
import { DEFAULT_LIVE_CHAT_SECTION_COLORS } from '../../constants/DefaultLiveChatSectionColors';
import type { Utils } from './UtilsProvider.types';

const prependExampleCom = (src: string): string => `https://example.com/${src}`;

export const defaultUtils: Utils = {
  getBlankSectionStructure: () => new StructureBuilder().build(),
  shouldUseTextThemes: () => false,
  shouldShowMyDesignsFooter: () => false,
  media: {
    getMediaUrl: prependExampleCom,
    getVideoIfAvailable: prependExampleCom,
  },
  translate: () => '',
  serviceTopology: {
    editorAssetsBaseUrl: '',
    itemsDataBaseUrl: '',
  },
  getRegistrySections: () => new Map(),
  theme: {
    fonts: {
      getMap: () => ({}),
    },
    textThemes: {
      getAll: () => ({}),
    },
  },
  hasSectionStyle: () => false,
  ThemedPreview: () => <div />,
  PersonalizedPreview: () => <div />,
  MobileToolsPanel: () => <div />,
  uiAnimations: {
    scrollTo: () => undefined,
  },
  getSuperAppData: () =>
    Promise.resolve({
      colorSvgIcon: '',
      appIcon: '',
      name: '',
      teaser: '',
    }),
  conditionHelpers: {
    isSectionAvailable: () => true,
    isRepeaterItem: () => false,
    isTPAInstalled: () => false,
    isSuperAppInstalled: () => false,
    isDataModeOn: () => false,
    isDevModeOn: () => false,
    isAdminPage: () => false,
    isMembersAppInstalled: () => false,
    isProvisionedOn: () => false,
    isMultilingualModeOn: () => false,
    isMobileEditorOn: () => false,
    isEducationModeOn: () => false,
    isInteractionModeOn: () => false,
    isLightboxModeOn: () => false,
    isFullWidthLightboxModeOn: () => false,
    hasSavedComponents: () => false,
    hasMyWidgets: () => false,
    isRefComponentSupported: () => false,
    isStaticPagesOverLimit: () => false,
    isConnectablePage: () => false,
    isCustomMenuEnabled: () => false,
    hasCustomTheme: () => false,
  },
  getLiveChatSectionColors: () => DEFAULT_LIVE_CHAT_SECTION_COLORS,
  processPlaceholders: identity,
};

export const UtilsContext = createContext<Utils>(defaultUtils);
